import script from "./BottomBar.vue?vue&type=script&setup=true&lang=js"
export * from "./BottomBar.vue?vue&type=script&setup=true&lang=js"

import "./BottomBar.vue?vue&type=style&index=0&id=2227e8fc&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2227e8fc"]])

export default __exports__